import { BaseLogo } from "../../../../core/models/entities/BaseLogo";
import { enviroment } from "../../../../enviroment";
import { useProductPendingPoll } from "../../../../hooks/useProductPendingPoll";
import { logoDetailKey } from "../../../../data/repositories/logoDetailCache";
import { isLogoUploadPending } from "../../../../utils/functions/productPending";
import { isSharpWaitActive } from "../functions/sharpWait";

// Flag REACT_APP_CLONE_INSTANT_ENABLED - build-time constant, so the export
// at the bottom is fixed for the lifetime of the bundle and hook order never
// varies at runtime (same idiom as useEditorLogoHeal).
const cloneInstantEnabled = enviroment.cloneInstantEnabled;

type EditorUploadPendingPoll = (logo: BaseLogo | null | undefined) => void;

/**
 * Editor-level "Preparing logo…" re-read (flag REACT_APP_CLONE_INSTANT_ENABLED).
 *
 * While the open logo is a clone whose supplier identity the API's
 * clone-upload worker still owes, re-read ONLY its own GetLogo entry
 * (["logos", actAs, id]) on the bounded 3/8/15 s schedule - max 3 calls per
 * pending logo, never a list call. The editor's heal subscription
 * (useEditorLogoHeal, flag REACT_APP_LOGO_HEAL_PER_MUTATION) delivers the
 * result and patchLogoFromDetail syncs uploadPending / serial, so the badge
 * clears and the locks open without F5.
 *
 * Flag REACT_APP_CLONE_INSTANT_SHARP_WAIT: while the clone is ALSO without a
 * genuine high-res (isSharpWaitActive) the faster re-read of
 * useEditorSharpWaitPoll owns the entry and this schedule stands down - the
 * same GetLogo clears the badge - so the two never double up. A clone that
 * opened on its source's high-res, or whose high-res landed while the
 * stamp is still set, is polled here exactly as before. Flag off = the
 * predicate is always false = unchanged.
 */
function useEditorUploadPendingPollEnabled(
  logo: BaseLogo | null | undefined
): void {
  const pending = isLogoUploadPending(logo) && !isSharpWaitActive(logo);
  useProductPendingPoll(
    pending && logo ? [logoDetailKey(logo.id)] : undefined,
    pending
  );
}

// Flag off: no hook body at all (no query-client read, no timer) - the call
// site keeps one hook call either way.
function useEditorUploadPendingPollDisabled(): void {}

export const useEditorUploadPendingPoll: EditorUploadPendingPoll =
  cloneInstantEnabled
    ? useEditorUploadPendingPollEnabled
    : useEditorUploadPendingPollDisabled;
